const MyResult = ()=>{
    return(
        <div>
            This is the result
        </div>
    )
}
export default MyResult